import React, { useMemo, useState } from "react";
import { Loader2, RefreshCw } from "lucide-react";

const ARTIFACT_LABELS = {
  discovery_summary: "Discovery Summary",
  project_yaml: "project.yaml",
  mvp_scope: "MVP-Scope",
  open_questions: "Offene Fragen",
  risk_register: "Risiko-Register",
  decision_log: "Entscheidungs-Log",
  prompt_seed: "Prompt Seed",
  problemstatement: "Problemstatement",
};

const ORDER = [
  "discovery_summary",
  "project_yaml",
  "open_questions",
  "risk_register",
  "prompt_seed",
  "mvp_scope",
  "decision_log",
  "problemstatement",
];

export default function SummaryView({ state, busy, onRegenerate }) {
  const artifacts = useMemo(() => {
    const arts = (state?.artifacts || []).filter(
      (a) => (a.content_yaml || "").trim() || (a.content_markdown || "").trim()
    );
    return arts.sort((a, b) => ORDER.indexOf(a.artifact_type) - ORDER.indexOf(b.artifact_type));
  }, [state]);
  const [active, setActive] = useState(null);
  const current = artifacts.find((a) => a.artifact_type === active) || artifacts[0];

  return (
    <div className="bg-card border border-border" data-testid="dlab-summary">
      <div className="border-b border-border px-6 py-3 flex items-center justify-between">
        <div className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">
          Ergebnis — maschinenlesbarer Projektkontext
        </div>
        <button
          type="button"
          onClick={onRegenerate}
          disabled={busy === "artifacts"}
          className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground disabled:opacity-60"
          data-testid="dlab-regenerate"
        >
          {busy === "artifacts" ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <RefreshCw className="w-3.5 h-3.5" />}
          Neu erzeugen
        </button>
      </div>

      {artifacts.length === 0 ? (
        <div className="px-6 py-10 text-sm text-muted-foreground">Noch keine Artefakte. Erzeugen Sie den Projektkontext aus der Readiness-Ansicht.</div>
      ) : (
        <div className="grid grid-cols-12">
          <div className="col-span-12 md:col-span-3 border-b md:border-b-0 md:border-r border-border">
            {artifacts.map((a) => (
              <button
                key={a.artifact_type}
                type="button"
                onClick={() => setActive(a.artifact_type)}
                className={
                  "w-full text-left px-5 py-3 border-l-2 transition-colors " +
                  (current?.artifact_type === a.artifact_type
                    ? "border-l-aw-coral bg-secondary"
                    : "border-l-transparent hover:bg-secondary/60")
                }
                data-testid={`dlab-artifact-${a.artifact_type}`}
              >
                <div className="text-sm font-medium text-foreground">{ARTIFACT_LABELS[a.artifact_type] || a.artifact_type}</div>
                <div className="font-mono text-[10px] text-muted-foreground mt-0.5">v{a.version}</div>
              </button>
            ))}
          </div>
          <div className="col-span-12 md:col-span-9">
            {current ? (
              <pre className="font-mono text-xs leading-relaxed whitespace-pre-wrap px-6 py-5 max-h-[65vh] overflow-y-auto text-foreground">
                {(current.content_yaml || "").trim() || (current.content_markdown || "").trim()}
              </pre>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
}
